import React, {Component} from 'react'
import {connect} from "react-redux";
import {Col, Row} from "react-bootstrap";
import BackLink from '../../../../common/back-link';
import PageTitle from "../../../../common/page-title";
import {getGroups, getProducts} from "../../../../../actions/products";
import {getPromotion, savePromotion, updatePromotion} from "../../../../../actions/promotions";
import {actions, Form} from "react-redux-form";
import RequiredSelect from "../../../../common/form/elements/required-select";
import RequiredInput from "../../../../common/form/elements/required-input";
import RequiredDatePicker from '../../../../common/form/elements/required-datepicker';
import RequiredMultiSelect from "../../../../common/form/elements/required-multi-select";
import ArrowButton from '../../../../common/button-arrow';

class NewPromotion extends Component {
  constructor(props) {
    super(props);
    this.id = this.props.match.params.id;
  }

  componentDidMount() {
    const {dispatch} = this.props;
    dispatch(getProducts());
    dispatch(getGroups());
    if (this.isEdit()) {
      dispatch(getPromotion(this.id)).then((promotion) => {
        dispatch(actions.load('deep.admin_promotion_save', promotion));
      });
    } else {
      dispatch(actions.reset('deep.admin_promotion_save'));
    }
  }

  componentWillUnmount() {
    this.props.dispatch({type: 'CLEAR_PROMOTIONS'});
    this.props.dispatch(actions.reset('deep.admin_promotion_save'));
  }

  isEdit = () => this.id && parseInt(this.id);

  isPromotionLoading = () => this.isEdit() && this.props.promotionLoading;

  handleSubmit = (payLoad) => {
    const {dispatch} = this.props;
    if (this.isEdit()) {
      dispatch(updatePromotion(this.id, payLoad));
    } else {
      dispatch(savePromotion(payLoad));
    }
  };

  createGroupList = groups => groups.map((curr) => ({
    label: `${curr.name}`,
    value: curr.id
  }));

  createProductList = products => products.flatMap((category) => (
    category.attributes.products.map((product) => ({
        label: `${product.name}`,
        value: product.id
      })
    )
  ));

  render() {
    const {promotion, groups: groupList, products: productList, savedGroups, formValid} = this.props;
    const products = this.createProductList(productList);
    const groups = this.createGroupList(groupList);
    const displayFromDate = promotion ? promotion.display_from_date : '';
    const displayToDate = promotion ? promotion.display_to_date : '';

    if (this.isPromotionLoading()) {
      return (
        <div className="container-fluid">
          <PageTitle>{this.isEdit() ? 'Edit Promotion' : 'Add Promotion'}</PageTitle>
          <Row>
            <Col lg={12}>
              Loading...
            </Col>
          </Row>
        </div>
      )
    }

    return (
      <div className="container-fluid">
        <Form model="deep.admin_promotion_save" onSubmit={(data) => this.handleSubmit(data)}>
          <Row>
            <Col lg={12}>
              <BackLink href="/admin/promotions"/>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <PageTitle>{this.isEdit() ? 'Edit Price Promotion' : 'Add Price Promotion'}</PageTitle>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <RequiredSelect
                model="deep.admin_promotion_save.product_id"
                values={products}
                label="Product"
                controlId="products"
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <RequiredInput
                label="Outer Price (&euro;)"
                model="deep.admin_promotion_save.outer_price"
                controlId="outer_price"/>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <RequiredDatePicker
                label='Display from date'
                placeholder='Display from date'
                model="deep.admin_promotion_save.display_from_date"
                controlId="display_from_date"
                value={displayFromDate}/>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <RequiredDatePicker
                label='Display to date'
                placeholder='Display to date'
                model="deep.admin_promotion_save.display_to_date"
                controlId="display_to_date"
                value={displayToDate}/>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <RequiredMultiSelect
                data={groups || []}
                label="Group(s)"
                value={savedGroups}
                controlId="groups"
                model='deep.admin_promotion_save.group_ids'/>
            </Col>
          </Row>
          <Row>
            <Col md={2} mdOffset={10}>
              <ArrowButton
                className="pull-right"
                arrow={false}
                disabled={!formValid}
              >
                Save
              </ArrowButton>
            </Col>
          </Row>
        </Form>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  formData: state.deep.admin_promotion_save,
  formValid: state.deep.forms.admin_promotion_save.$form.valid,
  promotion: state.promotions.promotion,
  products: state.products.products,
  productList: state.promotions.productList,
  product_id: state.deep.admin_promotion_save.product_id,
  promotionLoading: state.promotions.fetching && !state.promotions.fetched,
  savedGroups: state.deep.admin_promotion_save.group_ids || [],
  groups: state.groupSelector.groups || []
});

export default connect(mapStateToProps)(NewPromotion);



// WEBPACK FOOTER //
// ./src/components/admin/promotions/promotions/add/index.jsx